import {Component, Input, OnDestroy, OnInit,} from '@angular/core';
import { DetailsConfig, SharedUiDetailsModule } from '@snelstart/ui-details';
import { ButtonConfiguration, SharedUiButtonModule } from '@snelstart/ui-button';
import { Observable, Subject, takeUntil } from "rxjs";
import {
  BokkzAlgDataService,
  BokkzClient,
  BokkzUitstelDataService,
  BokkzUitstelLogic,
  UitstelGegevens,
  UitstelGegevensSoortUitstelVerzoek
} from "@snelstart-ventures/fiscaal/domain-logic";
import {ToastService} from "@snelstart/ui-toast";
import {FormBuilder} from "@angular/forms";
import { UitstelComponent } from '../uitstel/uitstel.component';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-tax-uitstel-details',
  templateUrl: './feature-tax-uitstel-details.component.html',
  styleUrl: './feature-tax-uitstel-details.component.scss',
  imports: [
    SharedUiButtonModule,
    SharedUiDetailsModule,
    UitstelComponent
  ]
})
export class FeatureTaxUitstelDetailsComponent implements OnInit, OnDestroy {

  @Input() public id!: string;
  public uitstelGegevens = {} as UitstelGegevens;
  public isIb = false;
  public isAangevraagd = false;
  public isToegekend = false;

  private destroy$ = new Subject<void>();

  protected readonly detailsConfig = DetailsConfig.create({
    hideArrowButtons: false,
  });

  public configSave() {
    return ButtonConfiguration.create({
      onClick: () =>
        new Observable((subscription) => {
          setTimeout(() => {
            subscription.next(true);
            subscription.complete();
            this.postUitstelGegevens(false, false)
          }, 200);
        }),
    })
  }

  public configRemove() {
    return ButtonConfiguration.create({
      onClick: () =>
        new Observable((subscription) => {
          setTimeout(() => {
            subscription.next(true);
            subscription.complete();
            this.postUitstelGegevens(true, false)
          }, 200);
        }),
    })
  }

  public configMore() {
    return ButtonConfiguration.create({
      onClick: () =>
        new Observable((subscription) => {
          setTimeout(() => {
            subscription.next(true);
            subscription.complete();
            this.postUitstelGegevens(false, true)
          }, 200);
        }),
    })
  }

  constructor(
    public algDataService: BokkzAlgDataService,
    public dataService: BokkzUitstelDataService,
    public bokkzClient: BokkzUitstelLogic,
    private bokkzAlgClient: BokkzClient,
    public toastService: ToastService,
    public fb: FormBuilder,
  ){}

  public ngOnInit(): void {
    this.dataService.uitstelGegevens
      .pipe(takeUntil(this.destroy$))
      .subscribe(value => this.uitstelGegevens = value);

    this.dataService.isIb
      .pipe(takeUntil(this.destroy$))
      .subscribe(value => this.isIb = value);

    this.dataService.isAangevraagd
      .pipe(takeUntil(this.destroy$))
      .subscribe(value => this.isAangevraagd = value);

    this.dataService.isToegekend
      .pipe(takeUntil(this.destroy$))
      .subscribe(value => this.isToegekend = value);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public postUitstelGegevens(remove : boolean, addUitstel : boolean) {
    if (remove) {
      this.uitstelGegevens.soortUitstelVerzoek = UitstelGegevensSoortUitstelVerzoek.AFMELDEN_UITSTEL;
    }
    if (addUitstel) {
      this.uitstelGegevens.soortUitstelVerzoek = UitstelGegevensSoortUitstelVerzoek.AANVULLEND_UITSTEL;
    }
    this.bokkzAlgClient.postPostponement(this.uitstelGegevens.fiscaalNummer, true, this.uitstelGegevens).subscribe({
      next: () => {
        this.dataService.updateGegevens(this.uitstelGegevens);
      },
      error: () => {
        console.log('error');
      },
      complete: () => {
        this.toastService.showSuccessMessage("Wijziging succesvol opgeslagen.")
      }
    })
  }
}
